export const FETCH_TITLE = 'FETCH_TITLE'
export const FETCH_TITLE_SUCCESS = 'FETCH_TITLE_SUCCESS'
export const FETCH_TITLE_FAILURE = 'FETCH_TITLE_FAILURE'

export const fetchTitle = () => ({
    type: FETCH_TITLE
})

export const fetchTitleSuccess = (title) => ({
    type: FETCH_TITLE_SUCCESS,
    payload: title
})

export const fetchTitleFailed = (message) => ({
    type: FETCH_TITLE_FAILURE,
    payload: message
})